import React, { useEffect } from "react";
const Vmodal = ({
  displayStatus,
  data,
  closeFunc,
  zIndex,
  timedClose,
  image,
  containerStyle,
}) => {
  useEffect(() => {
    if (displayStatus && closeFunc && timedClose) {
      timedCloseFunc();
    }
  });
  const timedCloseFunc = () => {
    setTimeout(() => {
      closeFunc();
    }, timedClose);
  };
  let display = "none";

  if (zIndex) {
    zIndex = zIndex;
  } else {
    zIndex = 999;
  }
  if (displayStatus) {
    display = "flex";
  }
  return (
    <section
      className="valertSection"
      style={{ display: display, zIndex: zIndex }}
    >
      <div
        className={image ? "valertContainerImage" : "valertContainer"}
        style={containerStyle}
      >
        {closeFunc && image ? (
          <div
            className="closeImage"
            onClick={closeFunc}
            style={{ 
              position: "absolute",
              zIndex: 1,
              cursor: "pointer",
              top: 5,
              right: 5
            }}
          >
            <i className="fas fa-times closeIcon" />
          </div>

        ) : (
          closeFunc &&
          !image && <i className="fas fa-times closeIcon" onClick={closeFunc} style={{ padding: 10 }} />
        )}
        {data}
      </div>
    </section>
  );
};
Vmodal.defaultValue = {
  containerStyle: "",
};
export default Vmodal;



// WEBPACK FOOTER //
// ./src/components/Vmodal.js